import { path } from 'ramda';

export const isUserLoggedIn = (userData) => !!(userData && userData.isLoggedIn);

export const getAttributeFromFile = (attributeName, file) => path([attributeName], file);
export const isValidFileType = (fileType, acceptedFileTypes) => fileType && acceptedFileTypes.indexOf(fileType) > -1;